// extracted by mini-css-extract-plugin
export default {"detailed-exposure":"style_detailed-exposure__-oWAp","risk-container":"style_risk-container__K5y3x","key-issues":"style_key-issues__Azv0n","container":"style_container__gubEw"};